module.exports = "../dist/frontend/icons/letters/a-white.svg?b286a1522b927e19649962fd32734ca2";